import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setSignupData } from "../../../redux/signup";
import EditBirthdate from "../../../components/EditBirthdate";
import { GAEventNames, GACategoryName, GAUniqueEventIds } from "../../../helpers/Enums";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const BirthdateQuestion = (props: any) => {
   const dispatch = useDispatch();
   //let history = useHistory();
   const register = useSelector((state: RootState) => state.signup);
   const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 6));


   const onSave = async (value: string) => {
      register.date_of_birth = value;
      dispatch(setSignupData(register));
      props.next();

      recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 9", "אישור גיל", GAUniqueEventIds.APP_SIGNUP)

   }


   return (
      <>
         {
            question ?

               <EditBirthdate
                  buttonText={"אפשר להמשיך"}
                  subtitle={question[0].questionSubTitle}
                  title={question[0].question}
                  value={register.date_of_birth} onSave={onSave} />
               :
               null
         }
      </>
   )
}

export default BirthdateQuestion;